import PropTypes from "prop-types";

// @mui material components
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import Icon from "@mui/material/Icon";

//   React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

//   React base styles
import typography from "assets/theme/base/typography";

function Footer({light}) {
  const {size} = typography;

  return (
    <MDBox
      sx={({breakpoints, palette}) => ({
        position: ["relative", "relative", "relative", "absolute", "absolute"],
        width: "100%",
        bottom: {lg: 0, xl: 0},
        py: 4,
        left: 0,
        background: light ? "transparent" : palette.background.paper,
        zIndex: 10
      })}
    >
      <Container>
        <MDBox
          width="100%"
          display="flex"
          flexDirection={{xs: "column", lg: "row"}}
          justifyContent="space-between"
          alignItems="center"
          px={1.5}
        >
          <MDBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexWrap="wrap"
            color={light ? "white" : "text"}
            fontSize={size.sm}
          >
            &copy; {new Date().getFullYear()},&nbsp; {/* made with */}
            {/* <MDBox fontSize={size.md} color={light ? "white" : "dark"} mb={-0.5} mx={0.25}>
              <Icon color="inherit" fontSize="inherit">
                favorite
              </Icon>
            </MDBox> 
            by*/}
            <Link href="https://bnt-soft.com/" target="_blank">
              <MDTypography variant="button" fontWeight="medium" color={light ? "white" : "dark"}>
                &nbsp;BNTSOFT PVT LTD&nbsp;
              </MDTypography>
            </Link>
            .
          </MDBox>
          <MDBox
            component="ul"
            sx={({breakpoints}) => ({
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              justifyContent: "center",
              listStyle: "none",
              mb: 0,
              p: 0,

              [breakpoints.up("lg")]: {
                mt: 0
              }
            })}
          >
            <MDBox component="li" pr={2} lineHeight={1}>
              <Link href="https://bnt-soft.com/" target="_blank">
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color={light ? "white" : "dark"}
                >
                  BNT SOFT
                </MDTypography>
              </Link>
            </MDBox>
            <MDBox component="li" px={2} lineHeight={1}>
              <Link href="https://bnt-soft.com/aboutus" target="_blank">
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color={light ? "white" : "dark"}
                >
                  About Us
                </MDTypography>
              </Link>
            </MDBox>
            <MDBox component="li" px={2} lineHeight={1}>
              <Link href="https://bnt-soft.com/resources/blogs" target="_blank">
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color={light ? "white" : "dark"}
                >
                  Blog
                </MDTypography>
              </Link>
            </MDBox>
            <MDBox component="li" pl={2} lineHeight={1}>
              <Link href="https://bnt-soft.com/buildwithus" target="_blank">
                <MDTypography
                  variant="button"
                  fontWeight="regular"
                  color={light ? "white" : "dark"}
                >
                  Contact Us
                </MDTypography>
              </Link>
            </MDBox>
          </MDBox>
        </MDBox>
      </Container>
    </MDBox>
  );
}

// Setting default props for the Footer
Footer.defaultProps = {
  light: false
};

// Typechecking props for the Footer
Footer.propTypes = {
  light: PropTypes.bool
};

export default Footer;
